import { NAME as APP_NAME } from 'constants';
import * as I18n from 'circe/I18n';

export const NAME = `${APP_NAME}/ORDER`;
export const REDUCER_NAME = 'order';
export const FORM_NAME = 'newOrder';

export const BOOKING_STEPS = {
  NEW: 'NEW',
  TOKENIZATION: 'TOKENIZATION',
  AUTHORIZATION: 'AUTHORIZATION',
  CONFIRMATION: 'CONFIRMATION',
  SD3: 'SD3',
  BOOKING: 'BOOKING',
  BOOKED: 'BOOKED',
  FAILED: 'FAILED',
};

export const MAX_NUMBER_OF_RESULTS = 6;
export const MAX_NUMBER_OF_DROPOFFS = 10;
export const MAX_NUMBER_OF_ITEMS = 10;
export const GOODS_LOADING_DURATION = 1800;
export const GOODS_UNLOADING_DURATION = 1800;

export const QUOTING_TYPES = {
  FTL: 'FTL',
  LTL: 'LTL',
};

export const APIs = {
  SEARCH: `${SHIPPING_EDGE}/api/shipments/quote`,
  SINGLE_LOAD: `${SHIPPING_EDGE}/api/quotes/shipment`,
  MULTIPLE_LOAD: `${SHIPPING_EDGE}/api/quotes/distribution`,
};
/**
https://en.wikipedia.org/wiki/Pallet#targetText=Square%20or%20nearly%20square%20pallets,by%20the%20Grocery%20Manufacturers%20Association. */
export const PREDEFINED_LOADS = [
  {
    label: I18n.str('BOX', 'Box'),
    value: 'BOX',
  },
  {
    label: I18n.str('PALLET_100_120', 'Pallet (100 X 120)'),
    value: 'PALLET_100_120',
    width: 100,
    length: 120,
  },
  {
    label: I18n.str('PALLET_110_110', 'Pallet (110 X 110)'),
    value: 'PALLET_110_110',
    width: 110,
    length: 110,
  },
  {
    label: I18n.str('PALLET_80_100', 'Pallet (80 X 100)'),
    value: 'PALLET_80_100',
    width: 80,
    length: 100,
  },
];

export const LTL_LOAD_DEFAULT_VALUE = {
  type: PREDEFINED_LOADS[0].value,
  quantity: 1,
  dimensions: {
    width: 0,
    height: 0,
    length: 0,
  },
  weight: 0,
};

export const QUOTING_STEPS = {
  QUOTING_TYPE: 0,
  EQUIPMENT_SELECTION: 1,
  SHIPMENT_DETAILS: 2,
  PICKUP_DELIVERY: 3,
};

export const ORDER_TYPES = {
  ORDER: 'ORDER',
  BATCH: 'BATCH',
  SPACE_RESERVATION: 'SPACE_RESERVATION',
};
